import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.authorization}invitations/oneTimeToken`;

interface GetOneTimeTokenQueryPayload {
  invitationId: string;
  invitationToken: string;
}

interface GetOneTimeTokenQueryResponse {
  oneTimeToken: string;
  invitationEmail: string;
}

const getOneTimeTokenQuery = async ({
  invitationId,
  invitationToken,
}: GetOneTimeTokenQueryPayload): Promise<
  BackResponse<GetOneTimeTokenQueryResponse> | BackResponseFailure
> => {
  try {
    const url = `${ENDPOINT}?InvitationId=${invitationId}&InvitationToken=${invitationToken}`;

    return await apiCall<BackResponse<GetOneTimeTokenQueryResponse>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getOneTimeTokenQuery;
